import {Component, Renderer2} from '@angular/core';

import {MenuResizeService} from "./menu.resizer.service";

@Component({
    selector: 'menu-resizer',
    template: require('./menu.resizer.template.html')
})
export class MenuResizer {

    private rootElement: any;
    private isLargeView: boolean = true;

    constructor(private renderer: Renderer2,
                private menuResizeService: MenuResizeService) {
    }

    private checkRootElementAvailability() {
        if (!this.rootElement) {
            this.rootElement = document.querySelector('.root-container');
        }
    }

    resize() {
        this.checkRootElementAvailability();
        this.isLargeView = !this.isLargeView;
        this.updateView(this.isLargeView);
        this.menuResizeService.changeSize(this.isLargeView);
    }

    updateView(isLarge: boolean) {
        if (isLarge) {
            this.renderer.addClass(this.rootElement, 'nav-md');
            this.renderer.removeClass(this.rootElement, 'nav-sm');
        } else {
            this.renderer.removeClass(this.rootElement, 'nav-md');
            this.renderer.addClass(this.rootElement, 'nav-sm');
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/menu/resizer/menu.resizer.component.ts